import { render, staticRenderFns } from "./TopTip.vue?vue&type=template&id=64c502fd&scoped=true&"
import script from "./TopTip.vue?vue&type=script&lang=js&"
export * from "./TopTip.vue?vue&type=script&lang=js&"
import style0 from "./TopTip.vue?vue&type=style&index=0&id=64c502fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.0_enyi6aqizbgycdmugvkasw26ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c502fd",
  null
  
)

export default component.exports